export default {
  loadConfigSuccess: (state, payload) => {
    state.newColorConfig = payload.newColorConfig;
    state.newFontsConfig = payload.newFontsConfig;
    state.newOtherConfig = payload.newOtherConfig;
  },
  setGlobalConfig: (state, { shop, ...data }) => {
    const dissallowedKeys = [
      'shop',
      'permissions',
      'serverUrl',
      'abTestActive',
      'is_trusted',
      'shopifyMetafieldsJsons',
    ];

    Object.keys(data).forEach(key => {
      if (dissallowedKeys.includes(key)) {
        delete data[key];
      }
    });

    state.globalConfig = data;
    state.shop = shop;
  },
  setNewFontsConfig: (state, payload) => {
    state.newFontsConfig = payload;
  },
  setNewOtherConfig: (state, payload) => {
    state.newOtherConfig = payload;
  },
  setNewColorConfig: (state, { param, value }) => {
    state.newColorConfig[param] = value;
  },
  setAllNewColorConfig: (state, payload) => {
    state.newColorConfig = payload;
  },
  incrementReviewsPerPage: state => {
    state.newOtherConfig.reviewsPerPage = parseInt(state.newOtherConfig.reviewsPerPage) + 1;
  },
  decrementReviewsPerPage: state => {
    state.newOtherConfig.reviewsPerPage = parseInt(state.newOtherConfig.reviewsPerPage) - 1;
  },
  setReviewColumns: (state, payload) => {
    state.newOtherConfig.reviewColumns = parseInt(payload);
  },
  setWidgetTheme: (state, payload) => {
    state.newOtherConfig.widgetTopSectionStyle = payload;
  },
  loadPluginDataSuccess: (state, payload) => {
    state.pluginData = payload.pluginData;
  },
  setActiveWidgets: (state, payload) => {
    state.activeWidgets = payload;
  },
  setSortingMethod: (state, payload) => {
    state.newOtherConfig['default_sorting'] = payload;
  },
};
